module.exports = __webpack_public_path__ + "media/pricing/ArtBooksProduct-1643bd20.png";